export default {
  title: {
    id: 'address_book_title',
    defaultMessage: 'Addresses',
  },
  introduction: {
    id: 'address_book_introduction',
    defaultMessage:
      'Create as many addresses as you want and assign them rules for specific scenario (markets, product categories and activities).',
  },
  createAddress: {
    id: 'address_book_create_new_address',
    defaultMessage: 'Create a new address',
  },
  createAddressModalTitle: {
    id: 'address_book_create_modal_title',
    defaultMessage: 'New address',
  },
  edit: {
    id: 'address_book_edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'address_book_delete',
    defaultMessage: 'Delete',
  },
  setDefault: {
    id: 'address_book_set_default',
    defaultMessage: 'Define as default',
  },
  onboardingModalTitle: {
    id: 'merchant_options_address_onboarding_modal_title',
    defaultMessage: 'Add your return address',
  },
  onboardingModalDescription: {
    id: 'merchant_options_address_onboarding_modal_done_section',
    defaultMessage:
      'Returns happen. Let’s make sure any of your returned items are delivered to the right place.',
  },
  onboardingModalToDoSection: {
    id: 'merchant_options_address_onboarding_modal_to_do_section',
    defaultMessage: 'Get started by adding your return address.',
  },
  onboardingModalDoneSection: {
    id: 'merchant_options_address_onboarding_modal_back_button_label',
    defaultMessage: 'Head back to the Onboarding page to continue.',
  },
  onboardingModalButtonLabel: {
    id: 'merchant_options_address_onboarding_modal_button_label',
    defaultMessage: 'Add return address',
  },
}
